import { Box, Text, Tip } from "grommet";
import React from "react";
import styled from "styled-components";

const TooltipWrapper = styled(Box)`
    .wrapper {
        border-radius: 5px;
        border: 1px solid rgba(255, 255, 255, 0.50);
        background: linear-gradient(180deg, rgba(208, 208, 208, 0.65) 0%, rgba(247, 248, 249, 0.65) 100%);
        box-shadow: 0px 25px 50px 0px rgba(1, 5, 22, 0.15);
        backdrop-filter: blur(50px);
    }
    .container {
        display: flex;
        width: 280px;
        padding: 20px 40px 20px 20px;
        flex-direction: column;
        align-items: flex-end;
        gap: 5px;

    }
    .contents {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;
        align-self: stretch;
    }
`

const Tooltip = ({ contents, node }) => {
    return (
        <TooltipWrapper className="wrapper">
            <Tip
                dropProps={{ align: { bottom: 'top' } }}
                content={
                    <div className="wrapper" >
                        <Box className="container">
                            <Text color='#030B33' className="contents">{contents}</Text>
                        </Box>
                    </div>
                }
            >
                {node}
            </Tip>

        </TooltipWrapper>
    );

}

export { Tooltip };